import { useState } from "react";

import "./multiValueInput.css";

export const MultiValueInput = ({
  values = [],
  onAdd,
  onRemove,
  label = "Asset",
  placeholder = "Asset DUID",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddValue = (e) => {
    e?.preventDefault();
    if (inputValue && !values.includes(inputValue)) {
      onAdd(inputValue);
      setInputValue("");
    }
  };

  const handleRemoveValue = (valueToRemove) => {
    onRemove(valueToRemove);
  };

  return (
    <>
      <div className="input-form-group">
        <label htmlFor="clientName">{label} *</label>
        <div className="multi-value-input-container">
          <input
            type="text"
            className="multi-value-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={placeholder}
          />
          <button onClick={handleAddValue}>+</button>
        </div>
      </div>

      {values.length > 0 && (
        <div className="input-form-group input-values-wrapper">
          {values.map((value, index) => (
            <div key={index} className="input-value-container">
              <span>{value}</span>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleRemoveValue(value);
                }}
              >
                ✖
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
